import React from 'react';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    id: 1,
    title: 'CHECKLIST CERO ERROR ANTES DE CORTAR',
    value: '$14 USD',
    imgText: 'Libro: Check List Cero Error',
    imgSrc: 'https://cdn.magicpatterns.com/uploads/2dbdwM7Q1enJjCtoYcfJNA/Check_list.png',
    desc: 'UN SISTEMA DE VERIFICACIÓN PREVIA Te evita errores costosos y te da seguridad antes de empezar cualquier trabajo.'
  }, {
    id: 2,
    title: 'ACELERADOR DE RESULTADOS',
    value: '$14 USD',
    imgText: 'Libro: Ruta Express 7 Días',
    imgSrc: 'https://cdn.magicpatterns.com/uploads/dRBZvRvW6TNPtSaf3bpcnN/Ruta_express.png',
    desc: 'RUTA EXPRESS 7 DÍAS – TALLER PROFESIONAL Elegí el proyecto a entregar de forma profesional.'
  }, {
    id: 3,
    title: 'PROYECTOS DE ALTO VALOR',
    value: '$14 USD',
    imgText: 'Libro: Planos de Trailers y Gym',
    imgSrc: 'https://cdn.magicpatterns.com/uploads/tL6BqUVgfm8YQEe21FYTp8/Proyecto_de_alto_valor.png',
    desc: 'PLANOS DE TRAILERS Y GYM Planos de proyectos grandes y rentables para dar el salto a trabajos que pagan mejor.'
  }, {
    id: 4,
    title: 'APRENDÉ A SOLDAR DESDE CERO',
    value: '$14 USD',
    imgText: 'Libro: Aprendé a Soldar Desde Cero',
    imgSrc: 'https://cdn.magicpatterns.com/uploads/5X15rQunqa7Uxp4xeG79rn/aprende_a_soldar.png',
    badge: '🎬 VIDEOS',
    desc: 'DE PRINCIPIANTE A SOLDADOR DE 7 DÍAS Aprendé a soldar de forma correcta y segura, desde cero.'
  }, {
    id: 5,
    title: 'PRESUPUESTO Y VENTAS',
    value: '$4.99 USD',
    imgText: 'Libro: Presupuesto y Ventas',
    imgSrc: 'https://cdn.magicpatterns.com/uploads/mLZ5svQcXxGGFQpGJDRuzt/presupuesto_y_ventas.png',
    desc: 'CIERRE GARANTIZADO Cómo presupuestar, presentar y cerrar trabajos.'
  }, {
    id: 6,
    title: 'APRENDÉ TORNERÍA DESDE CERO',
    value: '$14 USD',
    imgText: 'Libro: Aprendé Tornería Desde Cero',
    imgSrc: 'https://cdn.magicpatterns.com/uploads/kH5PRhcAjvpWDHWULpowN5/Aprende_Torneria.png',
    desc: 'FUNDAMENTOS CLAROS Para iniciarte en tornería y ampliar tus capacidades dentro del taller.'
  }, {
    id: 7,
    title: 'HERRERÍA ARTÍSTICA',
    value: '$14 USD',
    imgText: 'Libro: Herrería Artística',
    imgSrc: 'https://cdn.magicpatterns.com/uploads/iEfgCj3Qwkq4wWg56ehmSk/herreria_artistica.png',
    desc: 'PROYECTOS EXPLICADOS Para sumar diseño, estética y valor agregado a tus trabajos.'
  }, {
    id: 8,
    title: 'CARPINTERÍA QUE VENDE',
    value: '$14 USD',
    imgText: 'Libro: Carpintería Que Vende',
    imgSrc: 'https://cdn.magicpatterns.com/uploads/7rhXVLQJLKXYp16hegw6xd/herreria_artistica_(2).png',
    desc: '+100 PROYECTOS DE ALTA DEMANDA Más de 100 ideas de alta demanda para combinar madera y metal.'
  }];
  return <section className="py-4 bg-[#050505] text-white relative overflow-hidden" data-id="element-1">
      {/* Decorative background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-yellow-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-2"></div>

      <div className="max-w-[800px] mx-auto px-4 relative z-10" data-id="element-3">
        <div className="text-center mb-4" data-id="element-4">
          <div className="inline-flex items-center justify-center bg-yellow-500 text-slate-950 font-bold px-3 py-1 rounded-full mb-3 text-sm tracking-widest uppercase shadow-[0_0_20px_rgba(234,179,8,0.4)]" data-id="element-5">
            <Gift className="w-4 h-4 mr-1" data-id="element-6" />
            SOLO POR HOY
            <Gift className="w-4 h-4 ml-1" data-id="element-7" />
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-white uppercase" data-id="element-8">
            ¡LLEVATE 8 BONUS GRATIS!
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-2" data-id="element-9">
          {bonuses.map(bonus => <div key={bonus.id} className="bg-slate-900 border border-white/10 rounded-lg p-3 flex flex-col items-center relative overflow-hidden" data-id="element-10">
              {bonus.badge && <div className="absolute top-1 right-1 bg-red-600 text-white text-[8px] font-bold px-1.5 py-0.5 rounded-full z-10" data-id="element-11">
                  {bonus.badge}
                </div>}

              <div className="w-full aspect-square bg-slate-800 rounded-md overflow-hidden border border-white/5 mb-2 flex items-center justify-center" data-id="element-12">
                <img src={bonus.imgSrc} alt={bonus.imgText} className="w-full h-full object-contain object-center" data-id="element-13" />
              </div>

              <div className="w-full text-center flex flex-col flex-1" data-id="element-14">
                <div className="text-[10px] text-yellow-400 font-bold mb-1" data-id="element-15">
                  {bonus.value} · GRATIS
                </div>
                <h3 className="text-xs font-heading font-bold text-white uppercase leading-tight mb-1" data-id="element-16">
                  #{bonus.id}. {bonus.title}
                </h3>
                <p className="text-xs text-slate-400 leading-snug hidden md:block" data-id="element-17">
                  {bonus.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-4 text-center" data-id="element-18">
          <h3 className="text-lg md:text-xl font-heading font-bold text-white uppercase" data-id="element-19">
            APRENDÉ LAS TÉCNICAS DE HERRERÍA PROFESIONAL Y FABRICÁ MILES DE
            PROYECTOS RENTABLES
          </h3>
        </div>
      </div>
    </section>;
}